// extracted by mini-css-extract-plugin
export var callCard = "_kp-0";
export var callMessageButton = "_kp-1";
export var helpIcon = "_kp-3";
export var helpIconContainer = "_kp-4";
export var verticalDivider = "_kp-2";